import React, { useEffect, useState, useRef, useMemo } from "react";
import { View, TextInput, TouchableOpacity, Platform, } from "react-native";
import { styles } from "./InputQuantity.styles";
import { Text } from "../../../Text/Text";
const Control = ({ onPress, enabled, variant, ...props }) => {
    return enabled ? (React.createElement(TouchableOpacity, { onPress: onPress, style: [
            styles.button,
            variant === "small" ? styles.buttonSmall : styles.buttonLarge,
        ], ...props })) : (React.createElement(View, { style: [
            styles.button,
            variant === "small" ? styles.buttonSmall : styles.buttonLarge,
            // eslint-disable-next-line
            Platform.OS === "web" && { cursor: "not-allowed" },
            styles.disabledButton,
        ], ...props }));
};
export const InputQuantity = ({ min = 0, max = 99, start = 0, fieldDisabled = false, value, onChange, styles: userStyles, 
// Allows for counter to go back to zero if trying to decrement below minimum
resetOnDecrement = false, variant = "large", }) => {
    const directionRef = useRef(0);
    const quantityRef = useRef(value || start);
    const [quantity, setQuantity] = useState(value || start);
    const isMounted = useRef(false);
    const handleQuantityUpdate = () => {
        if (quantity !== quantityRef.current) {
            if (typeof quantityRef.current === "string") {
                /**
                 * The type will be a string if the user has typed into the field.
                 * - The field can be typed in if it's not disabled
                 */
                if (quantityRef.current !== "") {
                    const newQuantity = parseInt(quantityRef.current, 10);
                    quantityRef.current = newQuantity;
                }
            }
            if (quantityRef.current < min) {
                /**
                 * If below min but resetOnDecrement flag is true then set back to 0.
                 */
                if (resetOnDecrement && directionRef.current === -1) {
                    setQuantity(0);
                    quantityRef.current = 0;
                }
                else {
                    /**
                     * If the quantity is not set or is below the minimum, set to minimum.
                     */
                    setQuantity(min);
                    quantityRef.current = min;
                }
            }
            else if (quantityRef.current > max) {
                /**
                 * If the quantity is above the maximum, set to the maximum.
                 */
                setQuantity(max);
                quantityRef.current = max;
            }
            else {
                /**
                 * Push to the upper component if none of the other conditions match.
                 */
                setQuantity(quantityRef.current);
            }
        }
    };
    const handleDecrement = () => {
        directionRef.current = -1;
        quantityRef.current -= 1;
        handleQuantityUpdate();
    };
    const handleIncrement = () => {
        directionRef.current = 1;
        quantityRef.current += 1;
        handleQuantityUpdate();
    };
    const quantityDisplay = useMemo(() => (React.createElement(TextInput, { keyboardType: "numeric", autoComplete: "off", style: [
            styles.input,
            variant === "small" ? styles.inputSmall : styles.inputLarge,
            userStyles,
        ], 
        // lpingore to disable lastpass autofill on edge
        dataSet: { lpignore: "true" }, value: quantity.toString(), editable: !fieldDisabled, textAlign: "center", textAlignVertical: "center", testID: "quantity-input", onChangeText: (text) => {
            quantityRef.current = Number(text);
            handleQuantityUpdate();
            if (directionRef.current === 0) {
                onChange?.(quantityRef.current);
            }
        } })), [fieldDisabled, quantity]);
    useEffect(() => {
        if (isMounted.current) {
            onChange?.(quantity);
        }
        else {
            isMounted.current = true;
        }
    }, [quantity]);
    /**
     * Any changes made to internal quantity, reflect in upper component.
     */
    useEffect(() => {
        if (directionRef.current !== 0) {
            onChange?.(quantity);
        }
    }, [quantity]);
    /**
     * If we pass a value, set that to the default quantity value.
     */
    useEffect(() => {
        /**
         * If the value prop changes, update the quantity.
         */
        if (typeof value !== "undefined" && value !== quantity) {
            setQuantity(value);
            quantityRef.current = value;
        }
        else if (typeof value === "undefined" && directionRef.current !== 0) {
            setQuantity(0);
            quantityRef.current = 0;
        }
    }, [value]);
    return (React.createElement(View, { style: styles.wrap },
        React.createElement(Control, { variant: variant, enabled: quantity > min, onPress: handleDecrement },
            React.createElement(Text, { style: variant === "small"
                    ? styles.buttonTextSmall
                    : styles.buttonTextLarge }, "\u2212")),
        quantityDisplay,
        React.createElement(Control, { variant: variant, enabled: quantity < max, onPress: handleIncrement },
            React.createElement(Text, { style: variant === "small"
                    ? styles.buttonTextSmall
                    : styles.buttonTextLarge }, "+"))));
};
//# sourceMappingURL=InputQuantity.js.map